import { SelectAsyncInput } from '@core/components/Select';
import { vendaApi } from 'app/services/api/vendaApi';
import React from 'react';

const SelectVenda = ({
  id,
  name,
  label,
  value,
  touched,
  error,
  onBlur,
  onChange,
  required,
  disabled,
  soVendasAprovadas = false,
}) => {
  return (
    <SelectAsyncInput
      id={id}
      required={required}
      name={name}
      label={label}
      value={value}
      onChange={(event, value) => {
        onChange({
          target: {
            id,
            value,
          },
        });
      }}
      touched={touched}
      error={error}
      onBlur={onBlur}
      getOptionKey={(option) => {
        return option?.id;
      }}
      getOptionLabel={(option) => {
        if (option?.id) return `Venda ${option.identificador} - ${option?.nomeCliente}`;
      }}
      fetchData={async (query = '', next = 0) => {
        if (typeof query === 'object') {
          query = '';
        }

        const response = await vendaApi().buscarTodos({
          size: 100,
          sort: 'identificador',
          page: next,
          q: query,
        });

        if (soVendasAprovadas) {
          const data = response?.data?.content.filter((e) => e.situacao === 'VENDA_APROVADA') || [];

          data.forEach((venda) => {
            venda.identificador = venda.identificador.toString().padStart(3, '0');
          });

          return {
            data,
            nextPage: next,
            totalItems: data.totalElements,
          };
        } else {
          const data = response?.data?.content || [];
          return {
            data,
            nextPage: next,
            totalItems: data.totalElements,
          };
        }
      }}
      fetchOnFocus
      disabled={disabled}
    />
  );
};

export default SelectVenda;
